import {
    IonPage, IonContent, IonInput, IonTitle, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import './css/style.css';
import {withRouter} from "react-router-dom";
import {verifyCardInfo} from "./Service";
import cookieUtil from "../../../../utils/cookieUtil";


class RealNameAuthen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            getCodeMsg: "获取验证码",
            showNoticeTip: false,
            realName: '',
            idCard: '',
            token: null,
        }
    }


    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            this.setState({token: cookieUtil.get("access_token")})
            this.queryVerifyCardInfo();
        }
    }

    queryVerifyCardInfo = () => {
        const {token} = this.state;
        if (cookieUtil.has("access_token")) {
            const params = {
                'access_token': cookieUtil.get("access_token"),
            };
            console.log(params)
            verifyCardInfo(params).then(ret => {
                if (ret.code === '10000') {
                    this.setState({
                        realName: ret.data.idName,
                        idCard: ret.data.idCard
                    })
                } else {
                    this.setState({
                        isShowTip: true,
                        showTipMsg: ret.msg
                    })
                }
            }).catch(err => {
                console.log(err);
            });
        }

    }


    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }

    render() {
        const {realName, idCard} = this.state;

        return (
            <IonPage>
                <IonContent fullscreen>
                    <div className="sut_cont bggray">
                        <div className={"phone_top pr border-bottom-e6"}>
                            <div className="top_title">实名认证</div>
                        </div>
                        <div className="cont_kf" style={{paddingTop:'1rem'}}>
                            <div className="gs_cont">
                                <p className="tac textBlack"></p>
                                <p className="fs17"><span>姓名：</span>{realName}</p>
                                <p className="fs17"><span>身份证号：</span>{idCard}</p>
                                <p className="tac">温馨提示：根据国家相关法律法规要求<br/>
                                    91y用户需要使用有效身份证件进行实名认证</p>
                            </div>

                        </div>
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(RealNameAuthen);
